import EnvironmentVariables from "../../EnvironmentVariables";
import { defineLazyUrlProperties } from "../helper/runtime-api-url-box";

export const apiConstants = {
  apiController: {
    application: "application",
    technician: "technician",
    document: "document",
    ticket: "ticket",
    task: "task",
    passwordpusher: "passwordpusher",
    crm: "crm/contact",
    cx: "cx",
    client: "crm/client",
    asset: "asset",
    device: "asset/device",
    echoDistributor: "asset/echo/distributor",
    serviceprovider: "serviceprovider",
    calendar: "calendar",
    billing: "billing",
    billingContract: "billing/contract",
    integration: "integration",
    report: "report",
    xero: "xero",
    serviceproviderDevice: "serviceprovider/device",
    form: "form",
    trigger: "trigger",
    project: "project",
  },

  apiAction: {
    clientUrls: {
      alllocations: "location/list",
      locationget: "{id}/location/list",
      getdetail: "detail", //Include Id Query String
      listbyclientid: "list", //Include Id Query String
      clientList: "clientList",
      clientbytick: "tick/list",
    },

    ticketUrls: {
      ticketdetailbyid: "cx/detail",
      list: "cx/list",
      get: "comment/list",
      getcommentbycommentid: "comment",
      getcommentlistbytick: "comment/cx/tick/list",
      getcommentbyidforcx: "comment/cx",
      ticketbytick: "tick/cx/list",
      topcomment: "comment/top",
      addcomments: "comment/add",
      createencryptedtextlink: "link",
      getcommentlistbyfilter: "comment/cx/filter/list",
      getrecentcommentforcx: "cx/comment/recent",
      updatecomments: "comment",
      getcommentsbycommentids: "comment/list",
      getblobsharedaccesssignature: "blob/sastoken",
      setcommentreaction: "comment/reaction",
      setcommentccemail: "comment/ccemail",
      updatecontact: "contact",
      showhidecommentbyid: "showhide/comment",
      getComments: "ticket/comment/cx/filter/list",
      add: "cx/add",
      getconversationtabs: "conversation/cx",
      respondtoapproval: "approval/cx/respond",
      getcustomstatus: "custom/status/list",
      gettickettypelist: "type/list",
      gettickettagslist: "tags/list",
    },

    technicianUrls: {
      technicianlist: "list",
      joinSignalrGroups: "signalr/group/join",
      get: "email",
      getclientmembershipgroups: "client/subscribedgroups",
      getbyid: "detail",
      techniciantick: "tick/list",
      getClientGroupsAndEmailConfiguration: "client/{id}/groups",
      techniciangrouplist: "group/list",
    },

    AzureFunctionsUrls: {
      getSassToken: "/azure/storage/sastoken",
      createImageThumbnail: "/image/thumbnail",
    },

    PublicFunctionsUrls: {
      getFormById: "form",
      sendFormResponse: "sendformresponse",
      sendFormEmail: "sendemailforsubmittedform",
    },

    formUrls: {
      createshareablelink: "link",
      getformlist: "list",
      getformdraftlist: "formdraft/list/{createdById}",
      getformcontentbyformid: "content/{id}",
      getformdraftcontentbyformid: "formdraft/content/{id}",
      getformbyid: "{id}",
      createformdraft: "add/formdraft",
      updateformdraft: "update/formdraft",
      deleteformdraft: "formdraft/{id}",
    },

    documentUrls: {
      getdocumentbycontentid: "content/{id}",
      getdocumentlist: "list",
      getdocumentbydocumentid: "{id}",
    },

    contactUrls: {
      list: "list",
      contactbytick: "tick/list",
      getcontactsofothergroups: "other/group/list",
      getContactByEmail: "contact/email",
      getThemeId: "contact/theme",
      getcontacttaglist: "tag/list",
    },
    serviceProviderUrls: {
      getcustomdomainconfiguration: "custom/domain",
      getemailconfigurationlistbyserviceprovider: "email/configuration/list",
      doesemailconfigurationexist: "email/exist",
      getcxappconfiguration: "cxapplicationsettings",
      getinvoicetemplatelist: "email/invoice/template/list",
      getticketreopenthreshold: "ticketsettings",
      gettickettypesettings: "tickettypesettings",
      getserviceproiderworkingdays: "workingday",
      getserviceproviderlocation: "location",
    },
    billingUrls: {
      getinvoicebyid: "invoice",
      getinvoice: "invoice/cx/list",
      getinvoicesbytick: "invoice/cx/tick/list",
      downloadinvoice: "invoice/download",
      getinvoicelistbyid: "invoice/list",
      getPublicXeroLink: "invoice/xero/public/link",
      getinvoicecurrency: "invoice/currency",
      getcontracts: "contract/cx/list",
    },
    reportUrls: {
      getassetwarranty: "asset/warranty",
      getticketsummarylistreport: "ticket/summary/list",
      getticketsummaryreport: "ticket/summary",
    },
    projectUrls: {
      getProjectList: "cx/list",
      getProjectTypeList: "type/list",
      getProjectById: "cx/{projectId}",
    },
  },
};

export const constants = {
  apiUrl: {
    masterModuleUrl: {
      loaderUrl: "loaderModule/ShowLoader",
      CommentEditUrl: "loaderModule/ShowCommentEditLoader",
      defaultmasterDialog: "MasterModule/ShowDialog",
    },

    crmUrls: defineLazyUrlProperties({
      alllocations: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.client +
        "/" +
        apiConstants.apiAction.clientUrls.alllocations,
      getClientLocation: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.client +
        "/" +
        apiConstants.apiAction.clientUrls.locationget,
      getClientDetailById: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.client +
        "/" +
        apiConstants.apiAction.clientUrls.getdetail,
      getContactByEmail: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.cx +
        "/" +
        apiConstants.apiAction.contactUrls.getContactByEmail,
      getThemeId: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.cx +
        "/" +
        apiConstants.apiAction.contactUrls.getThemeId,
      getContactById: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        "{id}",
      getContactsOfOtherGroups: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        apiConstants.apiAction.contactUrls.getcontactsofothergroups,
      getContactListByClientId: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        apiConstants.apiAction.clientUrls.listbyclientid,
      getContactList: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        apiConstants.apiAction.contactUrls.list,
      getContactByTick: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        apiConstants.apiAction.contactUrls.contactbytick,
      getClientList: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.client +
        "/" +
        apiConstants.apiAction.clientUrls.clientList,
      getClientByTick: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.client +
        "/" +
        apiConstants.apiAction.clientUrls.clientbytick,
      getContactTagList: () =>
        EnvironmentVariables.rootCrmClientAPI() +
        "/" +
        apiConstants.apiController.crm +
        "/" +
        apiConstants.apiAction.contactUrls.getcontacttaglist,
    }),

    ticketUrls: defineLazyUrlProperties({
      getTicketDetailById: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.ticketdetailbyid,
      getAllTickets: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.list,
      getCosmosCommentByCommentId: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcommentbycommentid,
      getCommentByIdForCx: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcommentbyidforcx,
      getCommentListByTick: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcommentlistbytick,
      getTicketCosmosCommentById: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.topcomment,
      get: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.get,
      ticketbytick: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.ticketbytick,
      saveTicketComment: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.addcomments,
      createEncryptedTextLink: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.passwordpusher +
        "/" +
        apiConstants.apiAction.ticketUrls.createencryptedtextlink,
      getCommentListByFilter: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcommentlistbyfilter,
      getRecentCommentForCx: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getrecentcommentforcx,
      updateTicketComment: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.updatecomments,
      getCommentsByCommentIds: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcommentsbycommentids,
      getBlobSharedAccessSignature: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getblobsharedaccesssignature,
      setCommentReaction: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.setcommentreaction,
      updateticketcontact: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.updatecontact,
      setCommentCCEmail: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.setcommentccemail,
      showHideCommentById: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.showhidecommentbyid,
      getServiceProviderTicketTick: () =>
        EnvironmentVariables.getApimUrl() +
        "/tick-azure-function/api/ticket/tick",
      getTicketComments: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiAction.ticketUrls.getComments,
      saveTicket: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.add,
      getConversationTabs: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getconversationtabs,
      respondToApproval: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.respondtoapproval,
      getCustomStatus: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.getcustomstatus,
      getTicketTypeList: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.gettickettypelist,
      getTicketTagsList: () =>
        EnvironmentVariables.rootTicketUrlAPI() +
        "/" +
        apiConstants.apiController.ticket +
        "/" +
        apiConstants.apiAction.ticketUrls.gettickettagslist,
    }),

    technicianUrls: defineLazyUrlProperties({
      getTechniciansList: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.technicianlist,
      getTechnician: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.get,
      joinSignalrGroupsByRole: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.joinSignalrGroups,
      getClientMembershipGroups: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.getclientmembershipgroups,
      getTechnicianById: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.getbyid,
      getTechnicianByTick: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.techniciantick,
      getClientGroupsAndEmailConfiguration: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls
          .getClientGroupsAndEmailConfiguration,
      getTechniciansGroupList: () =>
        EnvironmentVariables.rootTechnicianUrlAPI() +
        "/" +
        apiConstants.apiController.technician +
        "/" +
        apiConstants.apiAction.technicianUrls.techniciangrouplist,
    }),

    CommonUrls: defineLazyUrlProperties({
      getEnumerations: () =>
        EnvironmentVariables.getApimUrl() + "/Enumeration/get",
      getMspCXSetting: () =>
        EnvironmentVariables.publicFunctionUrl() + "/api/GetMspCXSetting",
    }),

    azureBlob: defineLazyUrlProperties({
      getSasToken: () =>
        EnvironmentVariables.rootAzureBlob() +
        "/api" +
        apiConstants.apiAction.AzureFunctionsUrls.getSassToken,
    }),

    formUrls: defineLazyUrlProperties({
      createShareableLink: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.createshareablelink,
      getFormList: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.getformlist,
      getFormDraftList: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.getformdraftlist,
      getFormContentByFormId: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.getformcontentbyformid,
      getFormDraftContentByFormId: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.getformdraftcontentbyformid,
      getFormById: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.getformbyid,
      createForm: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.createformdraft,
      updateForm: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.updateformdraft,
      deleteFormDraft: () =>
        EnvironmentVariables.rootFormUrlAPI() +
        "/" +
        apiConstants.apiController.form +
        "/" +
        apiConstants.apiAction.formUrls.deleteformdraft,
    }),

    documentUrls: defineLazyUrlProperties({
      getPublicDocumentByContentId: () =>
        EnvironmentVariables.publicFunctionUrl() +
        "/api" +
        "/" +
        apiConstants.apiController.document,
      getDocumentByContentId: () =>
        EnvironmentVariables.documentApiUrlBase() +
        "/" +
        apiConstants.apiController.document +
        "/" +
        apiConstants.apiAction.documentUrls.getdocumentbycontentid,
      getDocumentList: () =>
        EnvironmentVariables.documentApiUrlBase() +
        "/" +
        apiConstants.apiController.document +
        "/" +
        apiConstants.apiAction.documentUrls.getdocumentlist,
      getDocumentByDocumentId: () =>
        EnvironmentVariables.documentApiUrlBase() +
        "/" +
        apiConstants.apiController.document +
        "/" +
        apiConstants.apiAction.documentUrls.getdocumentbydocumentid,
    }),

    serviceProviderUrls: defineLazyUrlProperties({
      getCustomDomainConfiguration: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getcustomdomainconfiguration,
      getEmailConfigurationListByServiceProvider: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls
          .getemailconfigurationlistbyserviceprovider,
      doesemailconfigurationexist: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.doesemailconfigurationexist,
      getCXAppConfiguration: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getcxappconfiguration,
      getInvoiceTemplateList: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getinvoicetemplatelist,
      getTicketReopenThreshold: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getticketreopenthreshold,
      getTicketTypeSettings: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.gettickettypesettings,
      getServiceProviderWorkingDays: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getserviceproiderworkingdays,
      getServiceProviderLocation: () =>
        EnvironmentVariables.serviceProviderApiUrlBase() +
        "/" +
        apiConstants.apiController.serviceprovider +
        "/" +
        apiConstants.apiAction.serviceProviderUrls.getserviceproviderlocation,
    }),

    billingUrls: defineLazyUrlProperties({
      getInvoiceById: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getinvoicebyid,
      getInvoice: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getinvoice,
      getInvoicesByTick: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getinvoicesbytick,
      downloadInvoice: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.downloadinvoice,
      getInvoiceListById: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getinvoicelistbyid,
      getPublicXeroLink: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getPublicXeroLink,
      getInvoiceCurrency: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getinvoicecurrency,
      getContracts: () =>
        EnvironmentVariables.billingApiUrlBase() +
        "/" +
        apiConstants.apiController.billing +
        "/" +
        apiConstants.apiAction.billingUrls.getcontracts,
    }),

    PublicFunctionsUrls: defineLazyUrlProperties({
      getFormById: () =>
        EnvironmentVariables.publicFunctionUrl() +
        "/api/" +
        apiConstants.apiAction.PublicFunctionsUrls.getFormById,
      sendFormResponse: () =>
        EnvironmentVariables.publicFunctionUrl() +
        "/api/" +
        apiConstants.apiAction.PublicFunctionsUrls.sendFormResponse,
      sendFormEmail: () =>
        EnvironmentVariables.publicFunctionUrl() +
        "/api/" +
        apiConstants.apiAction.PublicFunctionsUrls.sendFormEmail,
    }),

    reportUrls: defineLazyUrlProperties({
      getAssetWarrantyReport: () =>
        EnvironmentVariables.reportApiUrlBase() +
        "/" +
        apiConstants.apiController.report +
        "/" +
        apiConstants.apiAction.reportUrls.getassetwarranty,
      getTicketSummaryListReport: () =>
        EnvironmentVariables.reportApiUrlBase() +
        "/" +
        apiConstants.apiController.report +
        "/" +
        apiConstants.apiAction.reportUrls.getticketsummarylistreport,
      getTicketSummaryReport: () =>
        EnvironmentVariables.reportApiUrlBase() +
        "/" +
        apiConstants.apiController.report +
        "/" +
        apiConstants.apiAction.reportUrls.getticketsummaryreport,
    }),

    projectUrls: defineLazyUrlProperties({
      getProjectList: () =>
        EnvironmentVariables.projectApiUrlBase() +
        "/" +
        apiConstants.apiController.project +
        "/" +
        apiConstants.apiAction.projectUrls.getProjectList,
      getProjectTypeList: () =>
        EnvironmentVariables.projectApiUrlBase() +
        "/" +
        apiConstants.apiController.project +
        "/" +
        apiConstants.apiAction.projectUrls.getProjectTypeList,
      getProjectById: () =>
        EnvironmentVariables.projectApiUrlBase() +
        "/" +
        apiConstants.apiController.project +
        "/" +
        apiConstants.apiAction.projectUrls.getProjectById,
    }),
  },
  get validateIfUserLoggedIn() {
    return (window as any).GoreloWebDomain + "/validateIfUserLoggedIn";
  },
  localStorage: {
    keys: {
      rules: "rules",
      cxappsettings: "cxappsettings",
      magicLink: {
        accessToken: "magicLinkAccessToken",
        tokenExpiry: "magicLinkTokenExpiry",
      },
      authType: "CXAppAuthType",
    },
  },
  getToken: "https://gorelo-web-dev-dev.azurewebsites.net/getToken",
  get appInsightsKey() {
    return EnvironmentVariables.getAppInsightKey();
  },
  signalrMethods: {
    ticket: {
      ticketEntitySync: "ticketEntitySync",
      ticketPrivateCommentAdded: "ticketPrivateCommentAdded",
      ticketJoined: "ticketJoined",
    },
  },
  validations: {
    phoneNumberMinLength: 6,
    phoneNumberMaxLength: 15,
    emailMaxLength: 200,
  },
};

declare global {
  interface Window {
    UseAzureAdB2C: string;
    SignalRAzureFuncUrl: string;
    ApiSubscriptionKey: string;
    apiAuthCode: string;
    crmApiUrlBase: string;
    ticketApiUrlBase: string;
    technicianApiUrlBase: string;
    checkVersionUrl: string;
    azureBlobUrlBase: string;
    AzureStorageFileAccountName: string;
    appmailDomain: string;
    formApiUrlBase: string;
    azureTick: string;
    SetIdToken: Function;
    SetIsDesktopApp: (isDesktopApp: string) => Promise<void>;
    chrome: any;
    serviceProviderApiUrlBase: string;
    documentApiUrlBase: string;
    billingApiUrlBase: string;
    publicFunctionUrl: string;
    apimUrl: string;
    reportApiUrlBase: string;
    projectApiUrlBase: string;
  }
}
